import { formatAmountUnitDecimalPlace } from "@/utility/common";
import { useTranslation } from "react-i18next";

export const useBallotResultDef = (caseDataDetails: any) => {
  const { t } = useTranslation();

  const CustomHeader = () => {
    const { defaultUnit } = caseDataDetails;
    return `${defaultUnit?.name}`;
  };

  const amountCellRenderer = (field: string) => (params: any) => {
    const { defaultUnit } = caseDataDetails;
    const decimalPlace = field === "claim" ? defaultUnit?.decimalPlace : 2;
    const amount = params.data[field];
    let formatedAmount = formatAmountUnitDecimalPlace(amount, decimalPlace);
    return formatedAmount === "-"
      ? "-"
      : formatedAmount +
          ` ${
            !["claim", "latestDebtorAmount", "latestCreditorAmount"].includes(
              field
            )
              ? "%"
              : defaultUnit?.name
          }`;
  };
  return [
    {
      field: "voteType",
      headerName: t("pages.voting.ballotResult.columnDetails.column1"),
      flex: 1,
      sortable: true,
      unSortIcon: true,
      minWidth: 100,
    },
    {
      field: "votesCount",
      headerName: t("pages.voting.ballotResult.columnDetails.column2"),
      flex: 1,
      sortable: true,
      unSortIcon: true,
      cellRenderer: (params: any) =>
        params.data.votesCount !== null && params.data.votesCount !== undefined
          ? params.data.votesCount
          : "-",
      minWidth: 150,
    },
    {
      field: "votesCountPercentage",
      headerName: t("pages.voting.ballotResult.columnDetails.column3"),
      flex: 1,
      cellRenderer: amountCellRenderer("votesCountPercentage"),
      minWidth: 150,
    },
    {
      field: "latestCreditorAmount",
      headerName: t("pages.voting.ballotResult.columnDetails.column6", {
        unitName: CustomHeader(),
      }),
      flex: 1,
      cellRenderer: amountCellRenderer("latestCreditorAmount"),
      minWidth: 150,
    },
    {
      field: "latestCreditorAmountPercentage",
      headerName: t("pages.voting.ballotResult.columnDetails.column7"),
      flex: 1,
      cellRenderer: amountCellRenderer("latestCreditorAmountPercentage"),
      minWidth: 150,
    },
    {
      field: "latestDebtorAmount",
      headerName: t("pages.voting.ballotResult.columnDetails.column8", {
        unitName: CustomHeader(),
      }),
      flex: 1,
      cellRenderer: amountCellRenderer("latestDebtorAmount"),
      minWidth: 150,
    },
    {
      field: "latestDebtorAmountPercentage",
      headerName: t("pages.voting.ballotResult.columnDetails.column9"),
      flex: 1,
      cellRenderer: amountCellRenderer("latestDebtorAmountPercentage"),
      minWidth: 150,
    },
    {
      field: "claim",
      headerName: t("pages.voting.ballotResult.columnDetails.column4", {
        unitName: CustomHeader(),
      }),
      flex: 1,
      headerComponentParams: { params: "Claim Value" },
      cellRenderer: amountCellRenderer("claim"),
      minWidth: 150,
    },
    {
      field: "claimPercentage",
      headerName: t("pages.voting.ballotResult.columnDetails.column5"),
      flex: 1,
      cellRenderer: amountCellRenderer("claimPercentage"),
      minWidth: 150,
    },
  ];
};
